export function contactsByUserOrgBuilderForUI(contact) {
  return {
    familyID: contact.FamilyID,
    familyFullName: contact.FamilyFullName,
  };
}
